export default "__VITE_ASSET__DDxmFJ2o__"